<div class="au-comments-section">
	<div class="comments-list nice-scroll visible-scroll colored-scroll-track">
		@for (
			comment of commentsWithSeparators() | sortDate: 'created' : 'desc';
			track comment.id
		) {
			<div class="comment-item-wrapper">
				@if (comment.showSeparator) {
					<div class="separator">
						<div class="date-divider"></div>
						<div class="date">{{ comment.created | dateAgo: false }}</div>
						<div class="date-divider"></div>
					</div>
				}
				<entity-comment-item
					[requester]="requester()"
					[comment]="comment"
					(deleteCommentPressed)="deleteComment.emit({ commentId: $event })"
					(editCommentSubmitted)="editComment.emit($event)"
				/>
			</div>
		}
	</div>
	<div class="comment-input">
		<comment-input (commentSubmitted)="commentSubmitted.emit($event)" />
	</div>
</div>
